import type { PreviewIntegration } from '@/modules/Workspaces/KnowledgeHub/Integrations/integrationTypes'
import CrunchbaseLogo from './CrunchbaseLogo.vue'

export const crunchbaseIntegration: PreviewIntegration = {
  id: 'crunchbase',
  name: 'Crunchbase',
  description:
    'Enhance your AI with real-time Crunchbase data on companies, funding, and market trends.',
  icon: CrunchbaseLogo,
}
